import React, { useEffect } from 'react'
import './QuestionSummary.css'
import QuestionStatus from '../QuestionStatus/QuestionStatus'
import { HIDE_TIMER } from '../../constants/actionTypes'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'

const mapDispatchToProps = (dispatch) => ({
    hideTimer: (payload) => dispatch({ type: HIDE_TIMER, payload }),
})

const QuestionSummary = (props) => {
    useEffect(() => {
        const isMock = JSON.parse(sessionStorage.getItem('is_mock'))
        const isSubmitted = JSON.parse(sessionStorage.getItem('isSubmitted'))
        props.hideTimer(isMock && isSubmitted)
    }, [])
    return props.summary.map((data, index) => {
        return (
            <div
                key={index}
                className={`question-summary-list tab-content ${
                    props.active === index ? 'active' : ''
                }`}
            >
                <QuestionStatus status={data} {...props} />
            </div>
        )
    })
}

export default withRouter(connect(null, mapDispatchToProps)(QuestionSummary))
